export default "__VITE_ASSET__AQzoDQi1__"